const indexCheck = (index: number) => {
    return index === 15 || index === 22 || index === 29
}

const checkSettingBeforeSet = (cp: [], mdp: Array<Array<string>>, sp: Array<Array<string>>) => {
    let cpStatus = { isValid: false, message: "Заполните поле Cotir.def.param.group.ID" }
    let mdpStatus = { isValid: false, message: "Выберите хотя бы один MDP" }
    let spStatus = { isValid: false, message: "Заполните параметр Source.def.par.group.ID или все остальные" }

    cp.every((item, index) => index === 2 && item !== "" || index !== 2) ? cpStatus.isValid = true : cpStatus.isValid = false
    mdp.filter(item => item[5] === "True").length > 0 || mdp.length > 1 && mdp.every(item => item.length === 5) ? mdpStatus.isValid = true : mdpStatus.isValid = false
    sp.every(item => item[1] !== "" || item.slice(2).every(item => item !== "")) ? spStatus.isValid = true : spStatus.isValid = false
    // console.log({ cp, mdp, sp })
    // console.log({ cpStatus, mdpStatus, spStatus })
    return [cpStatus, mdpStatus, spStatus];
}

export default checkSettingBeforeSet
